import {
  currencies,
  ICountries,
  locales,
  Regions,
  TariffId,
} from "@/package/global-types";
import {
  IconKgSquare,
  IconRuSquare,
  IconUzSquare,
} from "@packages/icon-library";

export const COUNTRIES: ICountries = {
  KG: {
    auth: {
      source: import.meta.env.VITE_PASSPORT_SOURCE_KG,
      passportUrl: import.meta.env.VITE_PASSPORT_URL_KG,
    },
    defaultLocale: locales.KY,
    supportedLocales: [locales.KY, locales.RU, locales.EN, locales.UZ],
    currency: currencies.KGS,
    qualifications: {
      start: {
        requirements: {
          personallyInvitedL: 1,
          personallyInvitedR: 1,
          pv: 50,
        },
        bonuses: {
          linearBonus: true,
        },
      },
      expert: {
        requirements: {
          previousWeek: 3,
          currentWeek: 3,
          personallyInvitedL: 1,
          personallyInvitedR: 1,
          fromStart: 1,
          pv: 800,
        },
        bonuses: {
          linearBonus: true,
          careerBonus: 20000,
        },
      },
      star: {
        requirements: {
          previousWeek: 6,
          currentWeek: 6,
          lQualification: "start",
          rQualification: "start",
          personallyInvitedL: 1,
          personallyInvitedR: 1,
          pv: 1600,
        },
        bonuses: {
          linearBonus: true,
          careerBonus: 40000,
        },
      },
      double_star: {
        requirements: {
          previousWeek: 20,
          currentWeek: 20,
          lQualification: "expert",
          rQualification: "expert",
          pv: 8000,
        },
        bonuses: {
          linearBonus: true,
          leadershipBonus: true,
          careerBonus: 100000,
        },
      },
      diamond: {
        requirements: {
          previousWeek: 40,
          currentWeek: 40,
          lQualification: "star",
          rQualification: "star",
          pv: 20000,
        },
        bonuses: {
          linearBonus: true,
          leadershipBonus: true,
          careerBonus: 200000,
        },
      },
      double_diamond: {
        requirements: {
          previousWeek: 80,
          currentWeek: 80,
          lQualification: "double_star",
          rQualification: "double_star",
          pv: 40000,
        },
        bonuses: {
          linearBonus: true,
          leadershipBonus: true,
          careerBonus: 500000,
        },
      },
      grand_diamond: {
        requirements: {
          previousWeek: 120,
          currentWeek: 120,
          lQualification: "diamond",
          rQualification: "diamond",
          pv: 100000,
        },
        bonuses: {
          linearBonus: true,
          leadershipBonus: true,
          careerBonus: 750000,
        },
      },
      diamond_elite: {
        requirements: {
          previousWeek: 200,
          currentWeek: 200,
          lQualification: "double_diamond",
          rQualification: "double_diamond",
          pv: 160000,
        },
        bonuses: {
          linearBonus: true,
          leadershipBonus: true,
          careerBonus: 1000000,
        },
      },
      ambassador: {
        requirements: {
          previousWeek: 350,
          currentWeek: 350,
          lQualification: "grand_diamond",
          rQualification: "grand_diamond",
          pv: 300000,
        },
        bonuses: {
          linearBonus: true,
          leadershipBonus: true,
          careerBonus: 2000000,
        },
      },
      v_president: {
        requirements: {
          previousWeek: 600,
          currentWeek: 600,
          lQualification: "diamond_elite",
          rQualification: "diamond_elite",
          pv: 500000,
        },
        bonuses: {
          linearBonus: true,
          leadershipBonus: true,
          leadershipSecondBonus: true,
          careerBonus: 5000000,
        },
      },
    },
    quickStartBonus: [
      {
        tariffId: TariffId.BUSINESS_D,
        value: 18500,
      },
      {
        tariffId: TariffId.PREMIUM_D,
        value: 85000,
      },
      {
        tariffId: TariffId.VIP_D,
        value: 200000,
      },
    ],
    documents_groups: [
      {
        id: "presentationalMaterials",
        groupId: 18,
      },
      {
        id: "commissionPlan",
        groupId: 19,
      },
      {
        id: "legalDocuments",
        groupId: 17,
      },
    ],
    calculator: {
      [TariffId.BUSINESS_D]: {
        teamBonus: 110,
        quickStartBonus: 18500,

        [TariffId.SMART_C]: { RC: 800, PV: 1, CV: 0 },
        [TariffId.STANDARD_C]: { RC: 1000, PV: 1, CV: 1 },
        [TariffId.BUSINESS_D]: { RC: 1200, PV: 12, CV: 12 },
        [TariffId.PREMIUM_D]: { RC: 5800, PV: 20, CV: 20 },
        [TariffId.VIP_D]: { RC: 14400, PV: 20, CV: 20 },
      },

      [TariffId.PREMIUM_D]: {
        teamBonus: 130,
        quickStartBonus: 85000,

        [TariffId.SMART_C]: { RC: 800, PV: 1, CV: 0 },
        [TariffId.STANDARD_C]: { RC: 1000, PV: 1, CV: 1 },
        [TariffId.BUSINESS_D]: { RC: 1200, PV: 12, CV: 12 },
        [TariffId.PREMIUM_D]: { RC: 5800, PV: 58, CV: 58 },
        [TariffId.VIP_D]: { RC: 14400, PV: 58, CV: 58 },
      },

      [TariffId.VIP_D]: {
        teamBonus: 150,
        quickStartBonus: 200000,

        [TariffId.SMART_C]: { RC: 800, PV: 1, CV: 0 },
        [TariffId.STANDARD_C]: { RC: 1000, PV: 1, CV: 1 },
        [TariffId.BUSINESS_D]: { RC: 1200, PV: 12, CV: 12 },
        [TariffId.PREMIUM_D]: { RC: 5800, PV: 58, CV: 58 },
        [TariffId.VIP_D]: { RC: 14400, PV: 144, CV: 144 },
      },
    },
  },
  GH: {
    auth: {
      source: import.meta.env.VITE_PASSPORT_SOURCE_GH,
      passportUrl: import.meta.env.VITE_PASSPORT_URL_GH,
    },
    defaultLocale: locales.EN,
    supportedLocales: [locales.RU, locales.EN, locales.KY, locales.UZ],
    currency: currencies.GHS,
    qualifications: {
      start: {
        requirements: {
          personallyInvitedL: 1,
          personallyInvitedR: 1,
          pv: 51,
        },
        bonuses: {
          linearBonus: true,
        },
      },
      expert: {
        requirements: {
          previousWeek: 3,
          currentWeek: 3,
          personallyInvitedL: 1,
          personallyInvitedR: 1,
          fromStart: 1,
          pv: 800,
        },
        bonuses: {
          linearBonus: true,
          careerBonus: 20000,
        },
      },
      star: {
        requirements: {
          previousWeek: 6,
          currentWeek: 6,
          lQualification: "start",
          rQualification: "start",
          personallyInvitedL: 1,
          personallyInvitedR: 1,
          pv: 1600,
        },
        bonuses: {
          linearBonus: true,
          careerBonus: 40000,
        },
      },
      double_star: {
        requirements: {
          previousWeek: 20,
          currentWeek: 20,
          lQualification: "expert",
          rQualification: "expert",
          pv: 8000,
        },
        bonuses: {
          linearBonus: true,
          leadershipBonus: true,
          careerBonus: 100000,
        },
      },
      diamond: {
        requirements: {
          previousWeek: 40,
          currentWeek: 40,
          lQualification: "star",
          rQualification: "star",
          pv: 20000,
        },
        bonuses: {
          linearBonus: true,
          leadershipBonus: true,
          careerBonus: 200000,
        },
      },
      double_diamond: {
        requirements: {
          previousWeek: 80,
          currentWeek: 80,
          lQualification: "double_star",
          rQualification: "double_star",
          pv: 40000,
        },
        bonuses: {
          linearBonus: true,
          leadershipBonus: true,
          careerBonus: 500000,
        },
      },
      grand_diamond: {
        requirements: {
          previousWeek: 120,
          currentWeek: 120,
          lQualification: "diamond",
          rQualification: "diamond",
          pv: 100000,
        },
        bonuses: {
          linearBonus: true,
          leadershipBonus: true,
          careerBonus: 750000,
        },
      },
      diamond_elite: {
        requirements: {
          previousWeek: 200,
          currentWeek: 200,
          lQualification: "double_diamond",
          rQualification: "double_diamond",
          pv: 160000,
        },
        bonuses: {
          linearBonus: true,
          leadershipBonus: true,
          careerBonus: 1000000,
        },
      },
      ambassador: {
        requirements: {
          previousWeek: 350,
          currentWeek: 350,
          lQualification: "grand_diamond",
          rQualification: "grand_diamond",
          pv: 300000,
        },
        bonuses: {
          linearBonus: true,
          leadershipBonus: true,
          careerBonus: 2000000,
        },
      },
      v_president: {
        requirements: {
          previousWeek: 600,
          currentWeek: 600,
          lQualification: "diamond_elite",
          rQualification: "diamond_elite",
          pv: 500000,
        },
        bonuses: {
          linearBonus: true,
          leadershipBonus: true,
          leadershipSecondBonus: true,
          careerBonus: 5000000,
        },
      },
    },
    quickStartBonus: [
      {
        tariffId: TariffId.BUSINESS_D,
        value: 15000,
      },
      {
        tariffId: TariffId.PREMIUM_D,
        value: 70000,
      },
      {
        tariffId: TariffId.VIP_D,
        value: 150000,
      },
    ],
    documents_groups: [
      // {
      //   id: "presentationalMaterials",
      //   groupId: 3,
      //   description:
      //     "Instructions and assets for presenting products and services",
      // },
      // {
      //   id: "commissionPlan",
      //   groupId: 4,
      //   description: "Guides on earning strategy and income generation",
      // },
      {
        id: "legalDocuments",
        groupId: 17,
      },
    ],
    calculator: {
      partnerRewards: {
        [TariffId.BUSINESS_D]: {
          teamBonus: 101,

          [TariffId.SMART_C]: { RC: 800, PV: 1, CV: 0 },
          [TariffId.STANDARD_C]: { RC: 1000, PV: 1, CV: 1 },
          [TariffId.BUSINESS_D]: { RC: 1200, PV: 12, CV: 12 },
          [TariffId.PREMIUM_D]: { RC: 5800, PV: 20, CV: 20 },
          [TariffId.VIP_D]: { RC: 14400, PV: 20, CV: 20 },
        },

        [TariffId.PREMIUM_D]: {
          teamBonus: 125,

          [TariffId.SMART_C]: { RC: 800, PV: 1, CV: 0 },
          [TariffId.STANDARD_C]: { RC: 1000, PV: 1, CV: 1 },
          [TariffId.BUSINESS_D]: { RC: 1200, PV: 12, CV: 12 },
          [TariffId.PREMIUM_D]: { RC: 5800, PV: 58, CV: 58 },
          [TariffId.VIP_D]: { RC: 14400, PV: 58, CV: 58 },
        },

        [TariffId.VIP_D]: {
          teamBonus: 150,

          [TariffId.SMART_C]: { RC: 800, PV: 1, CV: 0 },
          [TariffId.STANDARD_C]: { RC: 1000, PV: 1, CV: 1 },
          [TariffId.BUSINESS_D]: { RC: 1200, PV: 12, CV: 12 },
          [TariffId.PREMIUM_D]: { RC: 5800, PV: 58, CV: 58 },
          [TariffId.VIP_D]: { RC: 14400, PV: 144, CV: 144 },
        },
      },
      quickStartByTariff: {
        [TariffId.FREE_C]: 900,
        [TariffId.SMART_C]: 900,
        [TariffId.STANDARD_C]: 900,
        [TariffId.BUSINESS_D]: 900,
        [TariffId.PREMIUM_D]: 4400,
        [TariffId.VIP_D]: 20000,
        [TariffId.VIP_GOLD_D]: 20000,
      },
      teamBonusCoefficients: {
        [TariffId.FREE_C]: 112.5,
        [TariffId.SMART_C]: 112.5,
        [TariffId.STANDARD_C]: 112.5,
        [TariffId.BUSINESS_D]: 110,
        [TariffId.PREMIUM_D]: 130,
        [TariffId.VIP_D]: 150,
        [TariffId.VIP_GOLD_D]: 150,
      },
    },
  },
  UZ: {
    auth: {
      source: import.meta.env.VITE_PASSPORT_SOURCE_UZ,
      passportUrl: import.meta.env.VITE_PASSPORT_URL_UZ,
    },
    defaultLocale: locales.UZ,
    supportedLocales: [locales.EN, locales.RU, locales.KY, locales.UZ],
    currency: currencies.UZS,
    qualifications: {
      start: {
        requirements: {
          personallyInvitedL: 1,
          personallyInvitedR: 1,
          pv: 51,
        },
        bonuses: {
          linearBonus: true,
        },
      },
      expert: {
        requirements: {
          previousWeek: 3,
          currentWeek: 3,
          personallyInvitedL: 1,
          personallyInvitedR: 1,
          fromStart: 1,
          pv: 800,
        },
        bonuses: {
          linearBonus: true,
          careerBonus: 3000000,
        },
      },
      star: {
        requirements: {
          previousWeek: 6,
          currentWeek: 6,
          lQualification: "start",
          rQualification: "start",
          personallyInvitedL: 1,
          personallyInvitedR: 1,
          pv: 1600,
        },
        bonuses: {
          linearBonus: true,
          careerBonus: 6000000,
        },
      },
      double_star: {
        requirements: {
          previousWeek: 20,
          currentWeek: 20,
          lQualification: "expert",
          rQualification: "expert",
          pv: 8000,
        },
        bonuses: {
          linearBonus: true,
          leadershipBonus: true,
          careerBonus: 15000000,
        },
      },
      diamond: {
        requirements: {
          previousWeek: 40,
          currentWeek: 40,
          lQualification: "star",
          rQualification: "star",
          pv: 20000,
        },
        bonuses: {
          linearBonus: true,
          leadershipBonus: true,
          careerBonus: 30000000,
        },
      },
      double_diamond: {
        requirements: {
          previousWeek: 80,
          currentWeek: 80,
          lQualification: "double_star",
          rQualification: "double_star",
          pv: 40000,
        },
        bonuses: {
          linearBonus: true,
          leadershipBonus: true,
          careerBonus: 75000000,
        },
      },
      grand_diamond: {
        requirements: {
          previousWeek: 120,
          currentWeek: 120,
          lQualification: "diamond",
          rQualification: "diamond",
          pv: 100000,
        },
        bonuses: {
          linearBonus: true,
          leadershipBonus: true,
          careerBonus: 112500000,
        },
      },
      diamond_elite: {
        requirements: {
          previousWeek: 200,
          currentWeek: 200,
          lQualification: "double_diamond",
          rQualification: "double_diamond",
          pv: 160000,
        },
        bonuses: {
          linearBonus: true,
          leadershipBonus: true,
          careerBonus: 150000000,
        },
      },
      ambassador: {
        requirements: {
          previousWeek: 350,
          currentWeek: 350,
          lQualification: "grand_diamond",
          rQualification: "grand_diamond",
          pv: 300000,
        },
        bonuses: {
          linearBonus: true,
          leadershipBonus: true,
          careerBonus: 300000000,
        },
      },
      v_president: {
        requirements: {
          previousWeek: 600,
          currentWeek: 600,
          lQualification: "diamond_elite",
          rQualification: "diamond_elite",
          pv: 500000,
        },
        bonuses: {
          linearBonus: true,
          leadershipBonus: true,
          leadershipSecondBonus: true,
          careerBonus: 750000000,
        },
      },
    },
    quickStartBonus: [
      {
        tariffId: TariffId.BUSINESS_D,
        value: 2500000,
      },
      {
        tariffId: TariffId.PREMIUM_D,
        value: 12000000,
      },
      {
        tariffId: TariffId.VIP_D,
        value: 28500000,
      },
    ],
    documents_groups: [
      // {
      //   id: "presentationalMaterials",
      //   groupId: 3,
      //   description:
      //     "Instructions and assets for presenting products and services",
      // },
      // {
      //   id: "commissionPlan",
      //   groupId: 4,
      //   description: "Guides on earning strategy and income generation",
      // },
      {
        id: "legalDocuments",
        groupId: 17,
      },
    ],
    calculator: {
      [TariffId.BUSINESS_D]: {
        teamBonus: 15000,
        quickStartBonus: 2500000,

        [TariffId.SMART_C]: { RC: 115000, PV: 1, CV: 0 },
        [TariffId.STANDARD_C]: { RC: 145000, PV: 1, CV: 1 },
        [TariffId.BUSINESS_D]: { RC: 220000, PV: 12, CV: 12 },
        [TariffId.PREMIUM_D]: { RC: 800000, PV: 20, CV: 20 },
        [TariffId.VIP_D]: { RC: 2000000, PV: 20, CV: 20 },
      },

      [TariffId.PREMIUM_D]: {
        teamBonus: 18000,
        quickStartBonus: 12000000,

        [TariffId.SMART_C]: { RC: 115000, PV: 1, CV: 0 },
        [TariffId.STANDARD_C]: { RC: 145000, PV: 1, CV: 1 },
        [TariffId.BUSINESS_D]: { RC: 220000, PV: 12, CV: 12 },
        [TariffId.PREMIUM_D]: { RC: 800000, PV: 58, CV: 58 },
        [TariffId.VIP_D]: { RC: 2000000, PV: 58, CV: 58 },
      },

      [TariffId.VIP_D]: {
        teamBonus: 21000,
        quickStartBonus: 28500000,

        [TariffId.SMART_C]: { RC: 115000, PV: 1, CV: 0 },
        [TariffId.STANDARD_C]: { RC: 145000, PV: 1, CV: 1 },
        [TariffId.BUSINESS_D]: { RC: 220000, PV: 12, CV: 12 },
        [TariffId.PREMIUM_D]: { RC: 800000, PV: 58, CV: 58 },
        [TariffId.VIP_D]: { RC: 2000000, PV: 144, CV: 144 },
      },
    },
  },
};

export const REGIONS = [
  {
    id: Regions.RUS,
    country_code: "RU",
    title: "RU",
    currency: currencies.RUB,
    icon: IconRuSquare,
    services: [
      { title: "RC OFFICE", link: import.meta.env.VITE_FRONTEND_URL_RU },
    ],
    bannerAlias: "main_slider_rus",
  },
  {
    id: Regions.KGZ,
    country_code: "KG",
    title: "KG",
    currency: currencies.KGS,
    icon: IconKgSquare,
    services: [
      { title: "RC OFFICE", link: import.meta.env.VITE_FRONTEND_URL_KG },
    ],
    bannerAlias: "main_slider_kgz",
  },
  // {
  //   id: Regions.GHA,
  //   title: "GH",
  //   country_code: "GH",
  //   currency: currencies.GHS,
  //   icon: IconGhSquare,
  //   services: [
  //     { title: "RC OFFICE", link: import.meta.env.VITE_FRONTEND_URL_GH },
  //   ],
  // },
  {
    id: Regions.UZB,
    country_code: "UZ",
    title: "UZ",
    currency: currencies.UZS,
    icon: IconUzSquare,
    services: [
      { title: "RC OFFICE", link: import.meta.env.VITE_FRONTEND_URL_UZ },
    ],
    bannerAlias: "main_slider_uzb",
  },
];
